import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { useAlertsInbox } from '../../api/hooks';
import { PageHeader, PanelCard, EmptyState, PagedFooter } from '../../components/ui';
import usePagination from '../../lib/usePagination';
import AlertSeverityBadge from '../../components/AlertSeverityBadge';
import AlertPayloadDetail from '../../components/ui/AlertPayloadDetail';
import { nameOr } from '../../lib/names';
import { useUserInfo } from '../../../react-query/queries';
import { useStudentLookup } from './sections/useStudentLookup';
import NeedsYouToday from './sections/NeedsYouToday';
import { greeting, todayEyebrow } from './sections/format';
import CoachLaunchButton from '../student_360/coach/CoachLaunchButton';

export default function CounselorDashboard() {
  const items = useAlertsInbox({}).data?.results ?? [];
  const students = useStudentLookup();
  const user = useUserInfo();
  const first = (user.data?.first_name || user.data?.name?.split(' ')[0] || '').trim();
  const pg = usePagination(items, 10);
  return (
    <>
      <PageHeader eyebrow={todayEyebrow()} title={first ? `${greeting()}, ${first}` : greeting()} subtitle="Students who need your attention today." trail={[]}
        actions={<CoachLaunchButton inline label="Ask the coach" scope={{ type: 'school' }} />} />
      <div className="grid grid-cols-12 gap-[18px]">
        <div className="col-span-12 flex flex-col min-[820px]:col-span-6 min-[1180px]:col-span-5 [&>section]:flex-1"><NeedsYouToday title="Wellbeing today" alerts={items} students={students} /></div>
        <PanelCard className="col-span-12 min-[820px]:col-span-6 min-[1180px]:col-span-7" title="Open wellbeing alerts">
          {items.length === 0 ? (
            <EmptyState icon={<ShieldCheck size={24} />} title="No open wellbeing alerts" body="No students currently flagged." />
          ) : (
            <>
            <ul>
              {pg.pageItems.map((a) => (
                <li key={a.id} className="border-b border-hairline py-3 last:border-0">
                  <div className="mb-2 flex items-center justify-between gap-2">
                    <AlertSeverityBadge severity={a.severity} />
                    <Link to={`/students/profile/${a.student_id}`} className="text-sm font-semibold text-ink no-underline hover:underline">{nameOr(a.student_name, a.student_username)}</Link>
                  </div>
                  <AlertPayloadDetail alert={a} />
                </li>
              ))}
            </ul>
            <PagedFooter from={pg.from} to={pg.to} total={pg.total} page={pg.page} pageCount={pg.pageCount} onPage={pg.setPage} label="Alerts pagination" className="mt-3" />
            </>
          )}
        </PanelCard>
      </div>
    </>
  );
}
